import React from 'react';
import "./LegalTrustStatus.scss";


function LegalTrustStatus() {
     function StatIcon({ children, className }) {
  return (
    <svg
      className={className}
      width="70"
      height="70"
      viewBox="0 0 64 64"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.65"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {children}
    </svg>
  );
}

function ShieldIcon(props) {
  return (
    <StatIcon {...props}>
      <path d="M32 7.5 46.2 13v11.2C46.2 34.3 40.5 43.1 32 47c-8.5-3.9-14.2-12.7-14.2-22.8V13L32 7.5Z" />
      <path d="m26.4 26.1 4 4 8-8.2" />
    </StatIcon>
  );
}

function PinIcon(props) {
  return (
    <StatIcon {...props}>
      <path d="M32 55s18-17.2 18-31.4C50 13.2 42.2 6 32 6s-18 7.2-18 17.6C14 37.8 32 55 32 55Z" />
      <circle cx="32" cy="23.5" r="7" />
    </StatIcon>
  );
}

function TrustHandIcon(props) {
  return (
    <StatIcon {...props}>
      <path d="M32 8.5 45.2 13.6v8.9c0 8.1-5.2 15.3-13.2 18.2-7.9-2.9-13.2-10.1-13.2-18.2v-8.9L32 8.5Z" />
      <path d="m26.4 21 4.1 4.1 8.1-8.7" />
      <path d="M8.8 45.8h8.5l8.8 5.6h14.1c3.2 0 6.2-1.2 8.5-3.4l7.4-7c1.2-1.1 1.2-2.9.1-4-1.1-1.1-2.8-1.2-4-.2l-8.5 6.4" />
      <path d="M17.3 45.8h18.6c1.8 0 3.2-1.4 3.2-3.2s-1.4-3.2-3.2-3.2h-9.6l-4.2-2.8c-1.6-1.1-3.6-1.7-5.6-1.7H8.8" />
    </StatIcon>
  );
}

function UmbrellaIcon(props) {
  return (
    <StatIcon {...props}>
      <path d="M10 31.4c2.8-10.2 11.7-17 22-17s19.2 6.8 22 17H10Z" />
      <path d="M32 14.4v34.3c0 4.1 6.2 4.1 6.2 0" />
      <path d="M18 31.4c1.2-8.7 6.1-17 14-17s12.8 8.3 14 17" />
    </StatIcon>
  );
}

function RegionalOfficeIcon(props) {
  return (
    <StatIcon {...props}>
      <path d="M18 52V16L32 10L46 16V52" />
      <path d="M26 52V40H38V52" />
      <path d="M24 20H28V24H24Z" />
      <path d="M36 20H40V24H36Z" />
      <path d="M24 28H28V32H24Z" />
      <path d="M36 28H40V32H36Z" />
    </StatIcon>
  );
}

const trustItems = [
  {
    icon: ShieldIcon,
    value: "35+",
    label: "Years of Excellence",
  },
  {
    icon: RegionalOfficeIcon,
    value: "7",
    label: "Regional Offices",
  },
  {
    icon: PinIcon,
    value: "42+",
    label: "Branches Nationwide",
  },
  
//   {
//     icon: TrustHandIcon,
//     value: "100K+",
//     label: "Happy Customers",
//   },
//   {
//     icon: UmbrellaIcon,
//     value: "50K+",
//     label: "Claims Settled",
//   },
];
const theme = "default";
  return (
    <section
      className={`legal-trust legal-trust--${theme}`}
      aria-labelledby={`${theme}LegalTrustTitle`}
    >
      <div className="legal-trust__heading">
        <h2 id={`${theme}LegalTrustTitle`}>YOUR TRUSTED INSURANCE PARTNER</h2>
        {/* <p>Building Credence since 1989</p> */}
      </div>

      <div className="legal-trust__grid">
        {trustItems.map(({ icon: Icon, value, label }) => (
          <article className="legal-trust__item" key={label}>
            <Icon className="legal-trust__icon" />
            <div>
              <strong>{value}</strong>
              <span>{label}</span>
            </div>
          </article>
        ))}
      </div>
    </section>
  )
}

export default LegalTrustStatus